exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-user{border-radius:1rem;border-color:#05bdbd;background:linear-gradient(0deg,rgba(5,189,189,.1),rgba(5,189,189,.5))}#myTab .active{background-color:transparent!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3e4076b6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/UserIdentify.vue
// module id = 528
// module chunks = 0